import classNames from 'classnames'
import { useEffect, useMemo, useRef } from 'react'

import styles from './MonthAndYearList.module.scss'

interface IYearList {
  selectYear: string
  filter: string
  onSelectYearChanged: (newYear: number) => void
}

export const DIRECTION_LENGTH = 31
const ACTUAL_YEARS_LENGTH = 4

export const YearList = ({ selectYear, filter, onSelectYearChanged }: IYearList) => {
  const rootRef = useRef<HTMLDivElement>(null)

  const yearList = useMemo(() => {
    const yearForShow = filter.length === ACTUAL_YEARS_LENGTH ? filter : selectYear
    const year = parseInt(yearForShow, 10)

    const length = DIRECTION_LENGTH * 2 + 1
    return new Array(length)
      .fill(0)
      .map((el, i) => year - DIRECTION_LENGTH + i)
      .filter((year) => year > 0)
  }, [selectYear, filter])

  useEffect(() => {
    if (rootRef.current) {
      const yearForSearch = filter.length === ACTUAL_YEARS_LENGTH ? filter : selectYear
      const currentYearDiv = rootRef.current.querySelector(
        `[data-year="${yearForSearch}"]`
      ) as HTMLDivElement
      if (currentYearDiv) {
        currentYearDiv.focus()
      }
    }
  }, [yearList, filter, selectYear])

  return (
    <div className={styles.root} ref={rootRef}>
      {yearList.map((year) => {
        const isActive = year + '' === selectYear
        const isFilteredItem = !isActive && year + '' === filter
        return (
          <div
            key={year}
            className={classNames(
              styles.item,
              isActive ? styles['item--active'] : '',
              isFilteredItem ? styles['item--filtered'] : ''
            )}
            onClick={() => onSelectYearChanged(year)}
            data-year={year}
            tabIndex={0}
          >
            {year}
          </div>
        )
      })}
    </div>
  )
}
